/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#containertest[_ngcontent-%COMP%], #world[_ngcontent-%COMP%]{width:100%;height:100%;overflow:hidden}#canvas[_ngcontent-%COMP%], #myviewerMapDom[_ngcontent-%COMP%]{width:100%;height:100%}.loadingBar[_ngcontent-%COMP%]{width:100%;height:100%;min-height:500px;max-height:80vh;background-color:#232334;-webkit-align-items:center;-ms-flex-align:center;justify-content:center;align-items:center;display:flex}"];
export { styles as styles };
